import { Ref, ref } from "vue";
import { KoyouKeiyakuService } from "@/service/KoyouKeiyakuService";
import { KeiyakuDetailWithSyuugyouBasyoAndBuka, SearchKoyouKeiyakuRes } from "@/types/KoyouKeiyaku"
import { useKoyouKeiyakuSearchStore } from "@/store/koyoukeiyaku-search";
import { DialogService } from "@/service/DialogService";

/*
* 検索処理
*/
export function useKoyouKeiyakuSearch() {
  const isError = ref(false)  // エラー判定

  // 検索条件に一致した契約書のリスト
  const KoyouKeiyakuList: Ref<SearchKoyouKeiyakuRes[]> = ref([]);
  const approvedKeiyakuList: Ref<KeiyakuDetailWithSyuugyouBasyoAndBuka[]> = ref([]);
  const changeableKeiyakuList: Ref<KeiyakuDetailWithSyuugyouBasyoAndBuka[]> = ref([]);

  // 検索サービスオブジェクト
  const srv = new KoyouKeiyakuService();

  const isSearching = ref(false);
  const getKoyouKeiyakuList = async () => {
    isSearching.value = true
    // storeから検索条件を読み出して実行
    const searchStore = useKoyouKeiyakuSearchStore()
    if(!searchStore.condition){
      DialogService.error({
        text: '検索条件が指定されていません'
      })
      return
    }

    KoyouKeiyakuList.value = await srv.searchKeiyaku(searchStore.condition)
    isSearching.value = false
  }

  const findAllApprovedByUserId = async (userId: number) => {
    isSearching.value = true
    const res = await srv.findAllApprovedByUserId(userId)
    approvedKeiyakuList.value = res
    isSearching.value = false
  }

  const findAllChangeableKoyouKeiyaku = async (userId: number) => {
    isSearching.value = true
    const res = await srv.findAllChangeableKoyouKeiyaku(userId)
    changeableKeiyakuList.value = res
    isSearching.value = false
  }

  return {
    isError,
    getKoyouKeiyakuList,
    KoyouKeiyakuList,
    isSearching,
    findAllApprovedByUserId,
    approvedKeiyakuList,
    findAllChangeableKoyouKeiyaku,
    changeableKeiyakuList
  }
}

